import React, { useState } from "react";
import { Link } from "react-router-dom";
import QRCode from "qrcode.react";
import authService from "../../services/authService";
import assessmentLocalStoregService from "../../services/assessmentLocalStoreg";

const Result = ({ match, history }) => {
  const type = match.params.type;
  const createId = match.params.createId;
  const binary = (+type).toString(2).padStart(5, "0");
  const result = {
    answer: binary,
    date: new Date(),
    createId,
  };

  result.username = authService.getUserInfoNormal();

  return (
    <>
      <div className="app-pages">
        <i
          style={{ fontSize: "32px", marginLeft: "18px", marginBottom: "15px" }}
          class="material-icons dp48"
          onClick={() => {
            history.push("/");
            return false;
          }}
        >
          arrow_back
        </i>
        <div className="had-container">
          {type === "0" && (
            <div className="survey-section">
              <div className="center">
                <p className="left">
                  You don't appear to have symptoms of COVID-19.
                </p>
                <QRCode
                  value={`${window.location.origin}/?result=${window.btoa(
                    JSON.stringify(result)
                  )}`}
                />
              </div>
            </div>
          )}

          {type === "4" && (
            <div className="survey-section">
              <p>Please get a COVID-19 test and self-isolate.</p>
            </div>
          )}

          {type === "7" && (
            <div className="survey-section">
              <p>
                Please get a COVID-19 test and self-isolate for at least 14 days
                or longer depending on when your symptoms started.
              </p>
            </div>
          )}

          {type === "6" && (
            <div className="survey-section">
              <p>
                Please get a COVID-19 test and self-isolate for at least 14 days
                or longer depending on when your symptoms started.
              </p>
            </div>
          )}

          {type === "5" && (
            <div className="survey-section">
              <p>
                Please get a COVID-19 test and self-isolate for at least 14 days
                or longer.
              </p>
            </div>
          )}

          {type === "8" && (
            <div className="survey-section">
              <p>Please consult your family doctor or nurse practitioner.</p>
            </div>
          )}

          {type === "16" && (
            <div className="survey-section">
              <p>
                Please call 9-1-1 or go directly to your nearset emergency
                department
              </p>
            </div>
          )}
          <div className="row center" style={{ paddingTop: "100px" }}>
            <Link
              to="/survey"
              className="waves-effect waves-light survey-welcome-button"
            >
              Retake The Self-Assessment
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Result;
